import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { employeeService } from '@services/employeeService';
import type { UserInfo } from '@/types';

/**
 * Hook to get the employee being viewed (for admin "view as" functionality)
 * - If there's an email URL parameter, fetches that employee's info
 * - Otherwise returns the logged-in user's info
 */
export const useViewingEmployee = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [viewingEmployee, setViewingEmployee] = useState<UserInfo | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchViewingEmployee = async () => {
      setIsLoading(true);
      try {
        const params = new URLSearchParams(location.search);
        const emailParam = params.get('email');

        console.log('useViewingEmployee: location.search changed:', location.search);
        console.log('useViewingEmployee: emailParam:', emailParam);

        if (emailParam) {
          // Admin is viewing as another employee
          const employeeInfo = await employeeService.getByEmail(emailParam);
          console.log('useViewingEmployee: fetched employee:', employeeInfo.employee_id, employeeInfo.email);
          setViewingEmployee(employeeInfo);
        } else {
          // View as self (logged-in user)
          console.log('useViewingEmployee: using logged-in user:', user?.employee_id, user?.email);
          setViewingEmployee(user);
        }
      } catch (error) {
        console.error('Failed to fetch viewing employee:', error);
        setViewingEmployee(user);
      } finally {
        setIsLoading(false);
      }
    };

    if (user) {
      fetchViewingEmployee();
    } else {
      setIsLoading(false);
    }
  }, [location.search, user]);

  return { viewingEmployee, isLoading };
};
